export default __webpack_public_path__ + "static/media/icon_add_user.8de86d14.svg";